<template>
  <div>
    <NoStayOrder :showActions="false"></NoStayOrder>
  </div>
</template>

<script>
import NoStayOrder from "../orderManage/noStayOrder/NoStayOrder.vue";
export default {
  name: "otherDbQueryStayOrder",
  components: { NoStayOrder },
  data() {
    return {};
  },
  created() {},
  methods: {}
};
</script>

<style lang="less" scoped></style>
